import VueWait from "vue-wait";
import Vue from "vue";

Vue.use(VueWait);

export default new VueWait({
    useVuex: true,              // Uses Vuex to manage wait state
    vuexModuleName: "wait",      // Vuex module name
    registerComponent: true,     // Registers `v-wait` component
    componentName: "v-wait",     // <v-wait> component name
    registerDirective: true,     // Registers `v-wait` directive
    directiveName: "wait",       // <span v-wait /> directive name
  });
